import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { siteIdAutoCompleteInput$, siteIdAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const renderSuggestion = (suggestion) => {
   return (
      <span>
         {suggestion.display}
      </span>
   );
};

const SiteAutoSuggest = renderAutoSuggestWithOptions(
   siteIdAutoCompleteObservable$,
   siteIdAutoCompleteInput$,
   renderSuggestion,
);

SiteAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Site Names...',
};

export default SiteAutoSuggest;
